<template>
    <div v-show="can.create.desk">
        <slot>
            <button-primary class="mr-2" @click="open">
                <template slot="icon"><i class="fa fa-plus"></i></template> Schreibtisch hinzufügen
            </button-primary>
        </slot>

        <portal to="modal" v-if="showPopup">
            <modal @close="showPopup = false">
                <template slot="header">Schreibtisch hinzufügen</template>

                <input-text class="mb-2" v-model="name">
                    Schreibtisch
                </input-text>

              <select-menu
                  class="mb-4"
                  v-model="floor_id"
                  :values="floors.map(g => g.id)"
                  :text="floors.map(g => g.name)">
                Etage
              </select-menu>

                <input-text class="mb-4" v-model="details">
                    Details z.B. 2. Etage
                </input-text>

                <navigation-edit v-model="desk" ></navigation-edit>


                <div class="flex justify-end">
                    <button-primary @click="submit">
                        <template slot="icon"><i class="fa fa-plus"></i></template> Schreibtisch hinzufügen
                    </button-primary>
                </div>
            </modal>
        </portal>
    </div>
</template>

<script>
import ButtonSecondary from "./UI/ButtonSecondary";
import ButtonPrimary from "./UI/ButtonPrimary";
import Modal from "./Modal";
import InputText from "./UI/InputText";
import NavigationEdit from "./NavigationEdit.vue";
import SelectMenu from "./UI/SelectMenu.vue";

export default {
    name: "DeskCreate",

    components: {SelectMenu, NavigationEdit, InputText, Modal, ButtonPrimary, ButtonSecondary},

    inject: ['can'],

    data: () => ({
        showPopup: false,
        name: '',
        floor_id: null,
        floors: [],
        details: '',
        type: 'default',
        desk: null
    }),

    methods: {
        open() {
            this.name = '';
            this.details = '';
            this.type = 'default';
          this.$http.get(`/admin/floors`)
              .then((response) => {
                this.floors = response.data.data;
                this.showPopup = true;
              }).catch(error => {
            this.$emit('error', error);
            this.loading = false;
          });
        },
        submit() {
          let apiParams = {
            '_method': 'post',
            name: this.name,
            floor_id: this.floor_id,
            details: this.details,
          };
          if(this.desk && this.desk.position){
            apiParams["position"]= this.desk.position;
          }
            window.axios.post('/admin/desks', apiParams)
                .then(() => {
                    this.name = '';
                    this.floor_id = null;
                    this.showPopup = false;
                    this.$emit('created');
                })
                .catch(error => {
                    this.$root.$emit('error', error);
                });
        },
    }
}
</script>

<style scoped>

</style>
